export const CHARGE_TYPES = {
  LateFee: 'LateFee',
  AccountSetup: 'AccountSetup',
  VacancyCostRecovery: 'VacancyCostRecovery',
  // InsufficientFundsFee: 'InsufficientFundsFee',
  AccountClosure: 'AccountClosure',
  OwnerAccountMaintenance: 'OwnerAccountMaintenance',
  TenantAccountMaintenance: 'TenantAccountMaintenance',
  PaperStatement: 'PaperStatement'
};
export const PAYMENT_METHODS = {
  ACH: 'ach',
  RegularCheck: 'regular-check'
};
export const TRANSACTION_TYPES = {
  CapCredit: 'Cap Credit',
  StatementCapCredit: 'Statement Cap Credit',
  CustomCharge: 'Custom Charge',
  CustomCredit: 'Custom Credit',
  Credit: 'Credit',
  Fee: 'Fee',
  LateFee: 'Late Fee',
  Payment: 'Payment',
  Refund: 'Refund',
  UtilityCharge: 'Utility Charge',
  UtilityCredit: 'Utility Credit',
  Void: 'Void',
  ConvenienceFeeCompensation: 'Convenience Fee Compensation',
  ConvenienceFee: 'Convenience Fee',
  CheckPayment: 'Check Payment',
  StripeFee: 'Stripe Fee',
  AdminFee: 'Admin Fee',
  PaperStatementFee: 'Paper Statement Fee'
};
export const TRANSACTION_TYPESV2 = {
  CapCredit: 'CapCredit',
  StatementCapCredit: 'StatementCapCredit',
  CustomCharge: 'CustomCharge',
  CustomCredit: 'CustomCredit',
  CheckPayment: 'CheckPayment',
  Credit: 'Credit',
  Fee: 'Fee',
  LateFee: 'LateFee',
  Payment: 'Payment',
  Refund: 'Refund',
  UtilityCharge: 'UtilityCharge',
  UtilityCredit: 'UtilityCredit',
  Void: 'Void',
  ConvenienceFeeCompensation: 'ConvenienceFeeCompensation',
  ConvenienceFee: 'ConvenienceFee',
  StripeFee: 'StripeFee',
  AdminFee: 'AdminFee',
  PaperStatementFee: 'PaperStatementFee'
};
export const PIE_CHART_COLORS_PALETTE = ['#e0cf0f', '#e3b556', '#b7ae04', '#f5770f', '#ff5e5e', '#f65625', '#24e134', '#27bb05', '#03b04a', '#0fee90', '#0ed280', '#0ebdae', '#08859b', '#1f8fff', '#1663f1', '#1729f8', '#bd07b4', '#9041ef', '#711fff', '#5e10e5'];
export const FEE_TYPES = {
  AccountSetup: 'AccountSetup',
  VacancyCostRecovery: 'VacancyCostRecovery',
  // InsufficientFundsFee: 'InsufficientFundsFee',
  AccountClosure: 'AccountClosure',
  OwnerAccountMaintenance: 'OwnerAccountMaintenance',
  TenantAccountMaintenance: 'TenantAccountMaintenance',
  PaperStatement: 'PaperStatement',
  LateFee: 'LateFee',
  ConvenienceFee: 'ConvenienceFee',
  BankTransferFee: 'BankTransferFee',
  PaperStatementFee: 'PaperStatementFee',
  AdminFee: 'AdminFee'
};
export const FEE_TYPES_NAME = {
  AccountSetup: 'Account Setup',
  VacancyCostRecovery: 'Vacancy Cost Recovery',
  // InsufficientFundsFee: 'Insufficient Funds Fee',
  AccountClosure: 'Account Closure',
  OwnerAccountMaintenance: 'Owner Account Maintenance',
  TenantAccountMaintenance: 'Tenant Account Maintenance',
  PaperStatement: 'Paper Statement',
  LateFee: 'Late Fee',
  ConvenienceFee: 'Convenience Fee',
  BankTransferFee: 'Bank Transfer Fee',
  PaperStatementFee: 'Paper Statement Fee',
  AdminFee: 'Admin Fee'
};
export const PAYMENT_METHOD_TYPE = {
  Card: 'Card',
  ACH: 'ACH'
};
export const TRANSACTION_STATUSES_NAMES = {
  New: 'New',
  InProgress: 'InProgress',
  Paid: 'Paid',
  Refunded: 'Refunded',
  Failed: 'Failed'
};
export const AMOUNT_TYPE = {
  percentage: 'Percentage',
  fixedAmount: 'FixedAmount'
};
export const RECCURING_TRANSACTION_STATUS = {
  Active: 'Active',
  Inactive: 'Inactive'
};
export const RECCURING_TRANSACTION_ENDING_CONDITION = {
  OnMoveOut: 'On Move Out',
  OnDate: 'On Date',
  OnNumberOfOccurrences: 'On Number Of Occurrences'
};
export const RECCURING_TRANSACTION_ENDING_CONDITION_KEYS = {
  OnMoveOut: 'OnMoveOut',
  OnDate: 'OnDate',
  OnNumberOfOccurrences: 'OnNumberOfOccurrences'
};
export const IS_PAYMENT_METHOD = 'livable_has_payment_method';